import React from "react";
import HOC from "../../components/HOC";
import DetailInvoice from "../../components/screen/invoice/DetailInvoice";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import BreadcrumbInvoice from "../../components/screen/invoice/BreadcrumbInvoice";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../components/constants/muiTheme";

const DetailInvoicePage = ({ isWarehouse }) => {
  return (
    <div className="">
      <PageTemplate
        header={`${isWarehouse ? "Central Warehouse" : ""} Detail Faktur`}
        mainComponent={
          <ThemeProvider theme={theme}>
            <DetailInvoice isWarehouse={isWarehouse ? isWarehouse : false} />
          </ThemeProvider>
        }
        breadcrumb={
          <BreadcrumbInvoice isWarehouse={isWarehouse ? isWarehouse : false} />
        }
        pageRole={isWarehouse ? 42 : 11}
      />
    </div>
  );
};

export default HOC(DetailInvoicePage);
